import { render, staticRenderFns } from "./toolbar-large.vue?vue&type=template&id=654cb0bb&"
import script from "./toolbar-large.vue?vue&type=script&lang=js&"
export * from "./toolbar-large.vue?vue&type=script&lang=js&"
import style0 from "./toolbar-large.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\uds\\projects\\alpheios\\components\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('654cb0bb', component.options)
    } else {
      api.reload('654cb0bb', component.options)
    }
    module.hot.accept("./toolbar-large.vue?vue&type=template&id=654cb0bb&", function () {
      api.rerender('654cb0bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vue/components/nav/toolbar-large.vue"
export default component.exports